import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  oversightDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-agendaItem-folder.controller';
import directive from './attach-agendaItem-folder.directive';


export default angular.module('app.components.advisory.oversight.attachAgendaItemFolder', [
  alerts,
  oversightDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('attachAgendaItemFolder', directive)
  .controller('AttachAgendaItemFolderController', controller)
  .name;

console.log('app.components.advisory.oversight.attachAgendaItemFolder created');
